/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
/* eslint-disable no-trailing-spaces */
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Helmet } from 'react-helmet';
import { THAILAND_TITLE, THAILAND_DESCRIPTION } from '../../Utils/Constants/SEO';
import ToursResultFunc from '../ToursResult/ToursResultFunc';
import { THAILAND_NAME } from '../../Utils/Constants/GlobalConstants';
import { getCountry } from '../../Utils/CommonUtils';

class Thailand extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getText = () => (
    <div>
      <div className="content_block">
        <h1 className="text_h1">Туры в Таиланд из Минска</h1>
        <p className="text_p">
          Таиланд — одно из самых популярных экзотических направлений у
          белорусских туристов. Тёплое Андаманское море и Сиамский залив,
          белоснежные пляжи, тропические острова, буддийские храмы и знаменитая
          тайская кухня — здесь каждый найдёт отдых по душе. Особенно Таиланд
          привлекателен зимой: пока в Беларуси снег, на тайских курортах
          начинается высокий сезон с солнечной погодой и спокойным морем.
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">Популярные курорты Таиланда</h2>
        <p className="text_p">
          1. <b>Пхукет</b> — крупнейший остров страны с десятками пляжей на любой
          вкус: от оживлённого Патонга с ночной жизнью до тихих Ката, Карон и
          Най Харн, которые подходят для семейного отдыха.
        </p>
        <p className="text_p">
          2. <b>Паттайя</b> — курорт недалеко от Бангкока с развитой
          инфраструктурой, аквапарками, шоу-программами и большим выбором
          недорогих отелей. Отсюда удобно ездить на экскурсии и на острова Ко
          Лан и Ко Самет.
        </p>
        <p className="text_p">
          3. <b>Самуи</b> — остров в Сиамском заливе с пальмовыми рощами,
          спокойной атмосферой и отелями уровня бутик и люкс. Хороший выбор для
          свадебного путешествия и размеренного отдыха.
        </p>
        <p className="text_p">
          4. <b>Краби и Као Лак</b> — живописные известняковые скалы, лагуны,
          национальные парки и близость к островам Пхи-Пхи и Симиланским
          островам — рай для любителей природы, снорклинга и дайвинга.
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">Когда лучше ехать в Таиланд?</h2>
        <p className="text_p">
          Высокий сезон на Пхукете, в Паттайе, Краби и Као Лаке длится с ноября
          по апрель: осадков мало, море спокойное, а температура воздуха
          держится около +30°C. С мая по октябрь на западном побережье идёт
          сезон дождей — тропические ливни обычно короткие, а цены на туры
          заметно ниже. На Самуи погода устроена иначе: самые дождливые месяцы
          там — октябрь и ноябрь, а летом остров отлично подходит для отдыха.
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">Как выбрать тур в Таиланд из Минска?</h2>
        <p className="text_p">
          1. Определитесь с курортом, датами, количеством ночей и составом
          туристов. Перелёт в Таиланд длительный, поэтому оптимальная
          продолжительность поездки — от 10 ночей.
        </p>
        <p className="text_p">
          2. Сравните предложения разных туроператоров: один и тот же отель у
          разных операторов может стоить по-разному. В поиске TourHunter все
          цены собраны в одном месте.
        </p>
        <p className="text_p">
          3. Бронируйте заранее. Новогодние праздники и зимние месяцы —
          самый востребованный период, и лучшие отели на эти даты разбирают
          быстро. Раннее бронирование помогает сэкономить и выбрать из большего
          числа вариантов.
        </p>
        <p className="text_p">
          4. Обратите внимание на тип питания. В Таиланде популярны туры с
          завтраками: уличная еда и местные кафе — отдельная часть путешествия,
          а система «всё включено» встречается реже, чем в Турции или Египте.
        </p>
        <p className="text_p">
          5. Для поездки понадобится загранпаспорт, срок действия которого
          составляет не менее 6 месяцев на дату въезда. Перед поездкой уточните
          актуальные визовые правила и обязательно оформите медицинскую
          страховку.
        </p>
      </div>
    </div>
  );

  render() {
    const text = this.getText();
    return (
      <div className="content">
        <Helmet>
          <title>{THAILAND_TITLE}</title>
          <meta name="description" content={THAILAND_DESCRIPTION} />

          <meta property="og:site_name" content="TourHunter.by" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://tourhunter.by/thailand/" />
          <meta property="og:title" content={THAILAND_TITLE} />
          <meta property="og:description" content={THAILAND_DESCRIPTION} />

          <link rel="canonical" href="https://tourhunter.by/thailand/" />
        </Helmet>
        <ToursResultFunc
          countryFilter={getCountry(THAILAND_NAME)}
          text={text}
        />
      </div>
    );
  }
}

export default Thailand;
